import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]
  static values = {
    addedEvents: Array
  }

  declare textareaTarget: HTMLTextAreaElement
  declare addedEventsValue: string[]

  connect() {
    if (!this.addedEventsValue) {
      this.addedEventsValue = []
    }
  }

  insertEvent(event: Event) {
    event.preventDefault()

    const button = event.currentTarget as HTMLElement
    const eventInfo = button.dataset.eventInfo
    const eventId = button.dataset.eventId

    if (!eventInfo || !eventId) {
      console.error('No event info or event ID found on button')
      return
    }

    if (this.addedEventsValue.includes(eventId)) {
      this.removeEvent(button, eventInfo, eventId)
      return
    }

    const lines = eventInfo.split('\n')
    const formattedEvent = lines.map(line => `  • ${line}`).join('\n')

    const text = this.textareaTarget.value
    const eventsHeader = "Folgende Events stehen zur Auswahl:"
    const closingLine = "Ich freue mich, Sie bei einem der Events zu sehen!"

    if (text.includes(eventsHeader)) {
      this.textareaTarget.value = text.replace(closingLine, formattedEvent + "\n\n" + closingLine)
    } else {
      const eventSection = eventsHeader + "\n\n" + formattedEvent
      this.textareaTarget.value = text.replace(closingLine, eventSection + "\n\n" + closingLine)
    }

    this.textareaTarget.scrollTop = this.textareaTarget.scrollHeight

    this.addedEventsValue = [...this.addedEventsValue, eventId]

    this.textareaTarget.classList.add('border-success')
    setTimeout(() => {
      this.textareaTarget.classList.remove('border-success')
    }, 1500)

    button.innerHTML = '<i class="fas fa-check"></i> Hinzugefügt'
    button.classList.add('btn-success')
    button.classList.remove('btn-primary')
    button.title = 'Klicken zum Entfernen'
  }

  removeEvent(button: HTMLElement, eventInfo: string, eventId: string) {
    const lines = eventInfo.split('\n')
    const formattedEvent = lines.map(line => `  • ${line}`).join('\n')

    let text = this.textareaTarget.value

    text = text.replace(formattedEvent + "\n\n", "")
    text = text.replace("\n\n" + formattedEvent, "")
    text = text.replace(formattedEvent, "")

    const eventsHeader = "Folgende Events stehen zur Auswahl:"
    if (text.includes(eventsHeader)) {
      const headerPos = text.indexOf(eventsHeader)
      const closingLine = "Ich freue mich, Sie bei einem der Events zu sehen!"
      const closingPos = text.indexOf(closingLine)

      const betweenText = text.substring(headerPos + eventsHeader.length, closingPos).trim()

      if (betweenText === "") {
        text = text.replace(eventsHeader + "\n\n", "")
      }
    }

    this.textareaTarget.value = text

    this.addedEventsValue = this.addedEventsValue.filter(id => id !== eventId)

    button.innerHTML = '<i class="fas fa-plus"></i>'
    button.classList.add('btn-primary')
    button.classList.remove('btn-success', 'btn-secondary')
    button.title = 'Event in Text einfügen'

    this.textareaTarget.classList.add('border-warning')
    setTimeout(() => {
      this.textareaTarget.classList.remove('border-warning')
    }, 1000)
  }

  copyText(event: Event) {
    event.preventDefault()

    const button = event.currentTarget as HTMLElement
    const originalHTML = button.innerHTML

    navigator.clipboard.writeText(this.textareaTarget.value).then(() => {
      button.innerHTML = '<i class="fas fa-check mr-1"></i>Kopiert!'
      button.classList.add('btn-success')
      button.classList.remove('btn-outline-dark')

      setTimeout(() => {
        button.innerHTML = originalHTML
        button.classList.remove('btn-success')
        button.classList.add('btn-outline-dark')
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err)
      button.innerHTML = originalHTML
    })
  }
}
